import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "page-width-inner pb-32 pt-16" }
const _hoisted_2 = {
  class: "grid grid-cols-4 gap-x-16 gap-y-32 tablet:gap-x-32 tablet:gap-y-64",
  style: {"grid-template-columns":"var(--collection-grid-columns)"}
}
const _hoisted_3 = {
  key: 2,
  class: "col-span-full py-32 text-20"
}
const _hoisted_4 = {
  key: 1,
  ref: "infiniteScrollTrigger",
  class: "h-10 w-full"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_grid_item_slider = _resolveComponent("grid-item-slider")
  const _component_grid_item = _resolveComponent("grid-item")
  const _component_grid_banner = _resolveComponent("grid-banner")
  const _component_grid_item_skeleton = _resolveComponent("grid-item-skeleton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!$data.loading && $data.gridData.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.gridData, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.type === 'product' ? item.id : `banner-${item.position}`
              }, [
                (item.type == 'product')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (item.media.length > 1)
                        ? (_openBlock(), _createBlock(_component_grid_item_slider, {
                            key: 0,
                            ref_for: true,
                            ref: "gridItem",
                            product: item,
                            "product-index": index + 1,
                            "lazyload-media": index > 8,
                            "enable-reviews": $props.enableReviews,
                            "hide-atc-button": $props.hideAtcButton
                          }, null, 8, ["product", "product-index", "lazyload-media", "enable-reviews", "hide-atc-button"]))
                        : (_openBlock(), _createBlock(_component_grid_item, {
                            key: 1,
                            ref_for: true,
                            ref: "gridItem",
                            product: item,
                            "product-index": index + 1,
                            "lazyload-media": index > 8,
                            "enable-reviews": $props.enableReviews,
                            "hide-atc-button": $props.hideAtcButton
                          }, null, 8, ["product", "product-index", "lazyload-media", "enable-reviews", "hide-atc-button"]))
                    ], 64))
                  : (_openBlock(), _createBlock(_component_grid_banner, {
                      key: 1,
                      banner: item
                    }, null, 8, ["banner"]))
              ], 64))
            }), 128)),
            ($data.loadingMore)
              ? (_openBlock(), _createBlock(_component_grid_item_skeleton, {
                  key: 0,
                  rep: $data.productsPerPage
                }, null, 8, ["rep"]))
              : _createCommentVNode("", true)
          ], 64))
        : ($data.loading)
          ? (_openBlock(), _createBlock(_component_grid_item_skeleton, {
              key: 1,
              rep: $data.productsPerPage
            }, null, 8, ["rep"]))
          : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($data.locale.no_products), 1))
    ]),
    ($data.isPaginationEnabled && $options.hasMoreProducts && $data.paginationType === 'load-more')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "btn btn-xsmall tablet:btn-medium btn-primary mx-auto mt-64",
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.addMoreProductsToGrid && $options.addMoreProductsToGrid(...args)))
        }, _toDisplayString($data.locale.load_more), 1))
      : ($data.isPaginationEnabled && $options.hasMoreProducts && $data.paginationType === 'infinite-scroll')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, null, 512))
        : _createCommentVNode("", true)
  ]))
}